import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {Observable, Subscription} from 'rxjs';
import {BulletinBoardPostLike} from '@app/core/models/bulletinBoardPostLike.model';
import {selectBulletinBoardPostLikedByInfo, selectBulletinBoardPostLikesPagination} from '@app/core/store/selectors/bulletin-board.selectors';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {BulletinPostsComponent} from '@app/modules/shared/components/bulletin-posts/bulletin-posts.component';
import {EQOColor, EQOIcon, EQORebrandColor, EQORebrandIcon} from '@quickorder/angular-web-lib';
import {BulletinBoardPost} from '@app/core/models/bulletinBoardPost.model';
import {Pagination} from '@app/core/models/pagination.model';
import {ClearLikes, GetPostLikedByInfo, GetPunchBulletinBoardPostInfoLikedBy} from '@app/core/store/actions/bulletin-board.actions';
import {filter} from 'rxjs/operators';
import {trackByIndex} from '@app/core/helpers';

@Component({
	selector: 'app-bulletin-board-post-likes-info',
	templateUrl: './bulletin-board-post-likes-info.component.html',
	styleUrls: ['./bulletin-board-post-likes-info.component.scss'],
})
export class BulletinBoardPostLikesInfoComponent implements OnInit, OnDestroy {

	public ICON = EQOIcon;
	public COLOR = EQOColor;
	public EQORebrandIcon: typeof EQORebrandIcon = EQORebrandIcon;
	public EQORebrandColor: typeof EQORebrandColor = EQORebrandColor;
	public postLikesInfo$: Observable<BulletinBoardPostLike[]> = this.store.select(selectBulletinBoardPostLikedByInfo);
	public postLikesInfoPagination$: Observable<Pagination> = this.store.select(selectBulletinBoardPostLikesPagination);
	public pagination: Pagination;

	public trackByIndex = trackByIndex;

	private _subscriptions: Subscription[] = [];

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { post: BulletinBoardPost, punchClock: boolean, likes: number },
		private store: Store<IAppState>,
		private dialogRef: MatDialogRef<BulletinPostsComponent>,
	) {
	}

	public ngOnInit(): void {
		if (this.data.punchClock) {
			this.store.dispatch(new GetPunchBulletinBoardPostInfoLikedBy(this.data.post));
		} else {
			this.store.dispatch(new GetPostLikedByInfo(this.data.post, 1, 10));
		}
		this._subscriptions.push(
			this.postLikesInfoPagination$.pipe(filter(p => p !== undefined)).subscribe(pag => {
				this.pagination = pag;
			}),
		);
	}

	public close(): void {
		this.dialogRef.close();
		this.ngOnDestroy();

	}

	public loadMore(): void {
		if (this.data.punchClock) {
			return;
		}
		this.store.dispatch(new GetPostLikedByInfo(this.data.post, this.pagination?.current_page + 1, 10));
	}

	public ngOnDestroy(): void {
		this.store.dispatch(new ClearLikes());
		this._subscriptions.forEach(s => s.unsubscribe());
	}

}
